exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-page-wrapper[data-v-6b2ca466] {\n  background: none;\n}\n.container[data-v-6b2ca466]{\n  padding:0;\n}\n", ""]);

// exports
